<template>
  <component
    :is="type"
    class="c-heading"
    :class="{
      [`c-heading--${display || level}`]: display || level,
    }"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  display?: number
  level?: number
}

const props = withDefaults(defineProps<Props>(), {
  display: undefined,
  level: 2,
})

const type = computed(() => `h${props.level}`)
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CHeading',
})
</script>
